import * as React from "react";
import { Helmet } from "react-helmet";
import { HOMEPAGE_FAQ_ITEMS, homepageFaqAnswerText } from "../../constants/homepage-faq";

export function FaqPageJsonLd(): React.ReactElement {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: HOMEPAGE_FAQ_ITEMS.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: homepageFaqAnswerText(item),
      },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
